module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "intro"
  }, [_c('section', {
    staticClass: "intro-shop"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("  活动举办方")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": _vm.shop_info.shop_logo
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-info"
  }, [_c('p', {
    staticClass: "of"
  }, [_vm._v(_vm._s(_vm.shop_info.shop_name || '微店卖家'))]), _vm._v(" "), (_vm.shop_info.weixin != '') ? _c('span', {
    staticClass: "of2"
  }, [_vm._v("微信：" + _vm._s(_vm.shop_info.weixin))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.shop_credit.credit_num), function(item) {
    return _c('li', {
      staticClass: "grade",
      class: _vm.gradeType
    })
  }))]), _vm._v(" "), _vm._v(" "), _c('a', {
    staticClass: "shop-btn",
    attrs: {
      "href": _vm.shop_info.shop_url
    }
  }, [_vm._v("进店逛逛")])])]), _vm._v(" "), _c('section', {
    staticClass: "intro-detail"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("  活动详情")]), _vm._v(" "), (_vm.description != '') ? _c('section', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _c('section', {
    staticClass: "no-detail"
  }, [_vm._v("暂无详情")]), _vm._v(" ")]), _vm._v(" "), _c('section', {
    staticClass: "intro-btn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("我也要创建")]), _vm._v(" "), _c('p', [_vm._v("注：本活动和奖品由商家支持，微店仅提供技术支持")])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-1bf0100b!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/intro.vue
 ** module id = 188
 ** module chunks = 3
 **/